import React, { useEffect } from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import useStyles from "./styles";
import ChangePasswordStrength from "./dialog/ChangePasswordStrength";
import ResetPassword from "./dialog/ResetPassword";
import securityActions from "./actions";
import { useSelector } from "react-redux";

const SecurityContainer = () => {
  const classes = useStyles();
  const { setPwdRstDialogOpen, setPwdStrengthDialogOpen, getSettings } =
    securityActions();
  const { security } = useSelector((state) => state.security);

  useEffect(() => {
    getSettings();
  }, [getSettings]);

  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));

  return (
    <Grid container>
      <Grid item xs={12} className={classes.header}>
        <Container>
          <Box className={classes.headerContainer}>
          <Typography variant="h6" style={{fontSize: '18px', fontWeight: 'bold', fontColor: '#323232', marginBottom:  "18px"}}>
              Security
            </Typography>
            <Typography variant="h6" style={{fontSize: '18px', fontWeight: 'normal', fontColor: '#323232'}}>Password Settings</Typography>
          </Box>
        </Container>
      </Grid>
      <Grid
        item
        xs={12}
        container
        direction="column"
        className={classes.content}
      >
        <Container>
          <Box m={1}>
            <Grid
              item
              sm={6}
              container
              justify="space-between"
              alignItems="center"
              className={classes.securityTab}
            >
              <Grid item container xs={12} sm={8} direction="column">
                <Typography variant="subtitle1">
                  Password strength: {security.password.policy_name}
                </Typography>
                <Typography variant="caption">
                  Set password requirements for everyone in your domain
                </Typography>
              </Grid>
              <Grid
                item
                container
                xs={12}
                sm={4}
                justify={matches ? "flex-end" : "flex-start"}
                alignContent="center"
              >
                <Box my={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setPwdStrengthDialogOpen(true)}
                  >
                    Change
                  </Button>
                </Box>
              </Grid>
            </Grid>
            <Grid
              item
              sm={6}
              container
              justify="space-between"
              alignItems="center"
              className={classes.securityTab}
            >
              <Grid item container xs={12} sm={8} direction="column">
                <Typography variant="subtitle1">Password reset</Typography>
                <Typography variant="caption">
                  Force password reset across all users. Reset individual’s
                  password in their Member profile settings
                </Typography>
              </Grid>
              <Grid
                item
                container
                xs={12}
                sm={4}
                justify={matches ? "flex-end" : "flex-start"}
                alignContent="center"
              >
                <Box my={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setPwdRstDialogOpen(true)}
                  >
                    Change
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Grid>
      <ChangePasswordStrength />
      <ResetPassword />
    </Grid>
  );
};

export default SecurityContainer;
